import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getMaintenancesAll } from '../../services'
import { BankQueryKeys } from '@/modules/bank/keys'
import { ProviderMaintenanceListResponse } from '@/modules/bank/type'

export default function useQueryGetMaintenancesAll(
	props?: UseBaseQueryOptions<ProviderMaintenanceListResponse>,
) {
	return useQuery({
		queryKey: [BankQueryKeys.MaintenancesAll],
		queryFn: getMaintenancesAll,
		...props,
	})
}
